import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics on mount
    initAnalytics();
  }, []);

  useEffect(() => {
    // Track page view on route transitions
    trackPageView(location.pathname + location.search);

    // Dynamic canonical URL injection for Search Console indexing alignment
    // Remove trailing slash for path consistency, except for root page
    const cleanPath = location.pathname.endsWith("/") && location.pathname !== "/"
      ? location.pathname.slice(0, -1)
      : location.pathname;
    const canonicalUrl = `https://uptimewing.com${cleanPath}`;

    let canonicalLink = document.querySelector("link[rel='canonical']");
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", canonicalUrl);
  }, [location]);

  return null; // This is a behavior-only component
}
